import $ from "jquery";

const init = () => {
  observeElement();
};

const observeElement = () => {
  if (!$(".mi-product-overview").length) return;

  const btn = document.querySelector(".mi-product-overview");
  const options = {
    attributes: true,
  };

  // eslint-disable-next-line no-unused-vars
  function callback(mutationList, observer) {
    // eslint-disable-line
    mutationList.forEach(function (mutation) {
      if (
        mutation.type === "attributes" &&
        mutation.attributeName === "class"
      ) {
        // handle class change
        fixPagination();
      }
    });
  }

  const observer = new MutationObserver(callback);
  observer.observe(btn, options);
};

const fixPagination = () => {
  const el = {
    paginationList: "a.page-numbers",
  };

  $(el.paginationList).each((idx, el) => {
    let paginationUrl = $(el).attr("href");
    let newPaginationUrl = removeURLParameter(paginationUrl, "wpf_page");
    $(el).attr("href", newPaginationUrl);
  });
};

function removeURLParameter(url, parameter) {
  var urlparts = url.split("?");
  if (urlparts.length >= 2) {
    var prefix = encodeURIComponent(parameter) + "=";
    var pars = urlparts[1].split(/[&;]/g);

    for (var i = pars.length; i-- > 0; ) {
      if (pars[i].lastIndexOf(prefix, 0) !== -1) {
        pars.splice(i, 1);
      }
    }

    return urlparts[0] + (pars.length > 0 ? "?" + pars.join("&") : "");
  }
  return url;
}

try {
  init();
} catch (error) {
  console.warn(error);
}
